
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","viewBox":"0 0 34 34","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 1C8.17775 1 1 8.17706 1 17C1 25.8229 8.17775 33 17 33C25.8223 33 33 25.8229 33 17C33 8.17706 25.8223 1 17 1ZM17 31.6667C8.91275 31.6667 2.33331 25.0872 2.33331 17C2.33331 8.91275 8.91275 2.33331 17 2.33331C25.0872 2.33331 31.6667 8.91275 31.6667 17C31.6667 25.0872 25.0872 31.6667 17 31.6667Z","fill":"currentColor","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M17.4714 11.8621C17.211 11.6016 16.7891 11.6016 16.5287 11.8621L9.19533 19.1954C8.93489 19.4558 8.93489 19.8777 9.19533 20.1381C9.45577 20.3985 9.87764 20.3985 10.138 20.1381L17 13.2761L23.862 20.1381C23.9922 20.2683 24.1628 20.3335 24.3334 20.3335C24.504 20.3335 24.6745 20.2683 24.8048 20.1381C25.0652 19.8777 25.0652 19.4558 24.8048 19.1955L17.4714 11.8621Z","fill":"currentColor","stroke":"currentColor"}})])
          )
        }
      }
    